import { NoddiTextArea } from '@ui-components/Inputs/NoddiTextArea';
import { useFieldContext } from '../formContext';
import { TanstackFieldError } from '../TanstackFieldError';
import { useTanstackFieldAria } from '../useTanstackFieldAria';

type Props = Omit<React.ComponentProps<typeof NoddiTextArea>, 'name' | 'value' | 'defaultValue'>;

export const TanstackFormTextArea = ({ rows = 3, onChange, onBlur, ...rest }: Props) => {
  const field = useFieldContext<string>();
  const fieldAria = useTanstackFieldAria(field, rest['aria-describedby']);

  return (
    <div>
      <NoddiTextArea
        {...rest}
        id={rest.id ?? field.name}
        name={field.name}
        {...fieldAria}
        value={field.state.value ?? ''}
        onBlur={(event) => {
          field.handleBlur();
          onBlur?.(event);
        }}
        onChange={(event) => {
          field.handleChange(event.target.value);
          onChange?.(event);
        }}
        rows={rows}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
